import { Box, Paper, Table, TableBody, TableContainer } from "@mui/material";
import { ITable } from "shared/components";
import styles from "../styles/autorizationPayments.module.scss";
import { CollapseRow } from "./CollapseRow";
import { FooterTable } from "shared/components/table/components/FooterTable";
import { useState } from "react";
import { HealthProviderType } from "../types";

interface Props extends ITable<any> {
  rowSelected: number[];
  selectAllRows: (
    event: React.ChangeEvent<HTMLInputElement>,
    rows: any,
  ) => void;
  selectRow: (
    event: React.ChangeEvent<HTMLInputElement>,
    id: any,
    row: any,
  ) => void;
  showBtnGenerateCertificate: boolean;
  onGenerateCertificate: () => void;
  providers: HealthProviderType[] | null;
  providersPage: number;
  providersSize: number;
  setProvidersPage: (page: number) => void;
  setProvidersSize: (size: number) => void;
  totalProviders: number;
  contentSizeProviders: number;
  providerInvoices: Record<string, any>;
  providerInvoicesPage: Record<string, number>;
  providerInvoicesSize: Record<string, number>;
  providerInvoicesLoading: Record<string, boolean>;
  getProviderInvoices: (providerCode: string, filters: any, page: number, size: number) => Promise<void>;
  setProviderInvoicesPage: (providerCode: string, page: number) => void;
  setProviderInvoicesSize: (providerCode: string, size: number) => void;
  filters: any;
}

export const TableCollapseAutorizations = (props: Props) => {
  const [sizeRows, setSizeRows] = useState("50");
  const {
    columns,
    valuesResultsPages,
    rowSelected,
    selectAllRows,
    selectRow,
    showBtnGenerateCertificate,
    onGenerateCertificate,
    providers,
    providersPage,
    providersSize,
    setProvidersPage,
    setProvidersSize,
    totalProviders,
    contentSizeProviders,
    providerInvoices,
    providerInvoicesPage,
    providerInvoicesSize,
    providerInvoicesLoading,
    getProviderInvoices,
    setProviderInvoicesPage,
    setProviderInvoicesSize,
    filters,
  } = props;


  const handleChangeSizePage = (event: any) => {
    const newSize = parseInt(event.target.value);
    setSizeRows(event.target.value);
    setProvidersSize(newSize);
    setProvidersPage(0);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setProvidersPage(newPage - 1);
  };

  return (
    <>
      {providers && providers.length > 0 ? (
        <Paper
          className={styles.containerTableResults}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <TableContainer className={styles.tableResults}>
            <Table data-testid="table-results" sx={{ minWidth: 700 }}>
              <TableBody>
                {providers.map((provider) => (
                  <CollapseRow
                    key={provider.id}
                    provider={provider.name}
                    providerCode={provider.id}
                    records={providerInvoices[provider.id]?.content || []}
                    columns={columns}
                    contentSize={providerInvoices[provider.id]?.content?.length || 0}
                    totalElements={providerInvoices[provider.id]?.totalElements || 0}
                    currentPage={providerInvoicesPage[provider.id] || 0}
                    currentSize={providerInvoicesSize[provider.id] || 50}
                    isLoading={providerInvoicesLoading[provider.id] || false}
                    rowSelected={rowSelected}
                    selectAllRows={selectAllRows}
                    selectRow={selectRow}
                    showBtnGenerateCertificate={showBtnGenerateCertificate}
                    onGenerateCertificate={onGenerateCertificate}
                    getProviderInvoices={getProviderInvoices}
                    setProviderInvoicesPage={setProviderInvoicesPage}
                    setProviderInvoicesSize={setProviderInvoicesSize}
                    filters={filters}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {valuesResultsPages && (
            <FooterTable
              handleChangePage={handleChangePage}
              handleChangeSizePage={handleChangeSizePage}
              numberPage={providersPage + 1}
              size={providersSize}
              sizeRows={sizeRows}
              totalElements={totalProviders}
              valuesResultsPages={valuesResultsPages}
              contentSize={contentSizeProviders}
            />
          )}
        </Paper>
      ) : (
        <Box
          className={styles.containerResults}
          data-testid="message_no_search"
        >
          No se encontraron resultados relacionados a su búsqueda
        </Box>
      )}
    </>
  );
};
